import {SERVER_GG_STORE_REPLY} from '../../constans/index';
import {
    GOOGLE_REVIEW_REQUEST,
    GOOGLE_REVIEW_SUCCESS,
    GOOGLE_REVIEW_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";
import queryString from "query-string";

const GoogleReviewCommentAction = (id, params = [], page = 1, limit = 50, sort = "created") => ({

    [RSAA]: {
        endpoint: () => {
            params.page = page;
            params.limit = limit;
            params.sort = sort;
            let query_param = queryString.stringify(params);

            return `${SERVER_GG_STORE_REPLY}/api/games/${id}/comments?${query_param}`
        },
        method: 'GET',
        headers: (headers()),
        types: [
            GOOGLE_REVIEW_REQUEST,
            {
                type: GOOGLE_REVIEW_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": GOOGLE_REVIEW_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: GOOGLE_REVIEW_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": GOOGLE_REVIEW_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {GoogleReviewCommentAction}